type ProposalPayload = {
    renewal?: boolean;
    renewalDate?: string;
    [key: string]: any;
};

export const applyProposalRenewalPayload = (
    payload: ProposalPayload,
    renewal: boolean,
    isRenewMode: boolean
): ProposalPayload => {
    if (isRenewMode) {
        payload.renewal = true;
        delete payload.renewalDate;
        return payload;
    }

    payload.renewal = renewal;
    return payload;
};
